// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentPdfFileStyleModel {
    static getAttributeTypeMap() {
        return DocumentPdfFileStyleModel.attributeTypeMap;
    }
}
DocumentPdfFileStyleModel.discriminator = undefined;
DocumentPdfFileStyleModel.additionalProperties = false;
DocumentPdfFileStyleModel.attributeTypeMap = [
    {
        "name": "styleName",
        "baseName": "styleName",
        "type": "string"
    },
    {
        "name": "fontName",
        "baseName": "fontName",
        "type": "string"
    },
    {
        "name": "fontSize",
        "baseName": "fontSize",
        "type": "number"
    },
    {
        "name": "colorFromCmyk",
        "baseName": "colorFromCmyk",
        "type": "string"
    },
    {
        "name": "color",
        "baseName": "color",
        "type": "string"
    },
    {
        "name": "bold",
        "baseName": "bold",
        "type": "boolean"
    },
    {
        "name": "pageBreakBefore",
        "baseName": "pageBreakBefore",
        "type": "boolean"
    },
    {
        "name": "spaceAfter",
        "baseName": "spaceAfter",
        "type": "number"
    },
    {
        "name": "tabStop",
        "baseName": "tabStop",
        "type": "string"
    },
    {
        "name": "tabStopAlignment",
        "baseName": "tabStopAlignment",
        "type": "string"
    },
];
//# sourceMappingURL=documentPdfFileStyleModel.js.map